var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongQuxiaozhiding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5h11",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.57 6.863L8.354 4.646a.5.5 0 00-.708 0l-4.5 4.5-.25.25a.5.5 0 00.708.708l.25-.25L7.5 6.207v3.935l1-1.068V6.207l1.386 1.387.684-.73zm.708.708l-.684.73 1.802 1.803a.5.5 0 00.708-.708l-1.826-1.825zM8.5 10.537l-1 1.068V14.5a.5.5 0 001 0v-3.963z",
    fill: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.895 13.105L13 4",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_quxiaozhiding.04d253d7.svg";
export { SvgTongyongQuxiaozhiding as ReactComponent };